
import { Component, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { readCookie } from '@/tools/tools';
import { invoiceList, deleteInvoice, pageVisit } from '@/services/http';

@Component({
  components: {
    Header,
    Price,
    Footer,
    DropDown,
    NavMenu
  }
})
export default class extends Vue {
  invoiceList: [] = []

  // 有无数据
  isNodata: boolean = false

  created() {
    this.getInvoiceList();
    this.pageVisit();
  }

  //  获取收货地址列表
  private async getInvoiceList() {
    const res: any = await invoiceList({ pageNo: 1, pageSize: 40, companyId: 1 });
    this.invoiceList = res.data.data;
    this.isNodata = res.data.data.length === 0;
  }

  // 编辑收货地址
  private editInvoice(id: number) {
    this.$router.push(`/invoiceedit?id=${id}`);
  }

  private deleteInvoice(id: number) {
    const $this = this;
    this.$confirm('确定删除该发票？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        const res: any = await deleteInvoice({
          id
        });
        if (res.data.code === 100) {
          $this.getInvoiceList();
          this.$message.success('删除成功!');
        } else {
          this.$message.error(res.data.message);
        }
      })
      .catch(() => {});
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 14,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }
}
